import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';

import { FormlibModule } from '@sondermind/formlib';
import { AccountEditModule } from '@sondermind/features/account-edit';
import { FAQAccordionModule } from '@sondermind/features/faq-accordion';
import { ClientCostEstimationComponent } from '@sondermind/features/client-facing/cost-estimation';

import { IrisButtonModule } from '@sondermind/iris/button';
import { IrisRadioGroupModule } from '@sondermind/iris/radio-group';
import { IrisIconComponent } from '@sondermind/iris/icon';
import { IrisProgressBarModule } from '@sondermind/iris/progress-bar';
import { IrisCardModule } from '@sondermind/iris/card';
import { IrisTextInputModule } from '@sondermind/iris/text-input';
import { IrisFormFieldModule } from '@sondermind/iris/form-field';

import { IrisCheckboxModule } from '@sondermind/iris/checkbox';
import { DesignModule } from '@sondermind/core/design.module';
import { CoreModule } from '@sondermind/core/core.module';

import { AccountSetupComponent } from './account-setup.component';
import { SetupAttestationAgreeComponent } from './components/setup-attestation-agree/setup-attestation-agree.component';
import { SetupBasicInfoComponent } from './components/setup-basic-info/setup-basic-info.component';
import { SetupEAPInfoComponent } from './components/setup-eap-info/setup-eap-info.component';
import { SetupInsuranceInfoComponent } from './components/setup-insurance-info/setup-insurance-info.component';
import { SetupPaymentInfoComponent } from './components/setup-payment-info/setup-payment-info.component';
import { SetupEbcgPaymentInfoComponent } from './components/setup-ebcg-payment-info/setup-ebcg-payment-info.component';
import { SetupProgressBarComponent } from './components/setup-progress-bar/setup-progress-bar.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatExpansionModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatInputModule,
    ReactiveFormsModule,

    IrisButtonModule,
    IrisRadioGroupModule,
    IrisIconComponent,
    IrisCardModule,
    IrisTextInputModule,
    IrisFormFieldModule,

    CoreModule,
    DesignModule,
    FormlibModule,

    AccountEditModule,
    FAQAccordionModule,
    IrisProgressBarModule,
    IrisCheckboxModule,
    ClientCostEstimationComponent
  ],
  declarations: [
    AccountSetupComponent,
    SetupAttestationAgreeComponent,
    SetupBasicInfoComponent,
    SetupInsuranceInfoComponent,
    SetupEAPInfoComponent,
    SetupPaymentInfoComponent,
    SetupEbcgPaymentInfoComponent,
    SetupProgressBarComponent
  ],
  exports: [AccountSetupComponent, SetupEbcgPaymentInfoComponent],
  providers: [],
})
export class AccountSetupModule {}
